import { authenticatedApiClient } from './authService';

interface UserProfile {
    university?: string;
    endowment_name?: string;
    activism_organization?: string;
    signal_id?: string;
}

interface UserData {
    id: number;
    username: string;
    email: string;
    first_name: string;
    last_name: string;
}

interface UserProfileResponse {
    user: UserData;
    profile: UserProfile;
}

interface UserUpdateData {
    first_name?: string;
    last_name?: string;
    userprofile?: UserProfile;
}

interface PasswordChangeData {
    current_password: string;
    new_password: string;
    confirm_password: string;
}


export const getUserProfile = async (): Promise<UserProfileResponse> => {
    try {
        const response = await authenticatedApiClient.get<UserProfileResponse>('/user/profile/');
        return response.data;
    } catch (error: any) {
        if (error.response?.data?.error) {
            throw new Error(error.response.data.error);
        }
        throw new Error('Failed to fetch user profile');
    }
};

export const updateUserProfile = async (userData: UserUpdateData): Promise<{ message: string; user: UserData }> => {
    try {
        const response = await authenticatedApiClient.put<{ message: string; user: UserData }>('/user/profile/', userData);
        return response.data;
    } catch (error: any) {
        if (error.response?.data?.error) {
            throw new Error(error.response.data.error);
        }
        if (error.response?.data) {
            const errors = Object.values(error.response.data).flat().join(', ');
            throw new Error(errors);
        }
        throw new Error('Failed to update profile');
    }
};

export const changePassword = async (passwordData: PasswordChangeData): Promise<{ message: string }> => {
    try {
        const response = await authenticatedApiClient.post<{ message: string }>('/user/change-password/', passwordData);
        return response.data;
    } catch (error: any) {
        if (error.response?.data?.error) {
            throw new Error(error.response.data.error);
        }
        if (error.response?.data) {
            const errors = Object.values(error.response.data).flat().join(', ');
            throw new Error(errors);
        }
        throw new Error('Failed to change password');
    }
};